import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo/uia-irol-logo.webp")